var LoginForm = (function($, window) {
    'use strict';

    function Form(btnSelector, containerSelector, url, config) {
        this.$btn = $(btnSelector);
        this.$container = $(containerSelector);
        this.url = url;
        this.username = $('#login-username');
        this.password = $('#login-password');

        this.config = $.extend({}, this.getDefaultConfig(), config);

        this.registerEvents();
    }

    Form.prototype = {
        getDefaultConfig: function () {
            var noop = function () {};

            return {
                onFailure: noop,
                onAuth: function() {
                    this.addMessage('success', 'Logging in. Please wait...').reloadPage();
                },
                onInvalid: function(response) {
                    this.addMessage('danger', response.error);
                }
            };
        },

        getConfig: function () {
            return this.config;
        },

        registerEvents: function() {
            var self = this;

            this.$btn.click(function(e) {
                self.login();

                e.preventDefault();
            });
        },

        login: function() {
            var self = this;

            this.removeMessage().addMessage('info', 'Checking credentials...');

            $.post(this.url, this.getParams())
                .success(function(response) {
                    self.removeMessage();

                    if(response.error) {
                        self.config.onInvalid.call(self, response);
                    }
                    else {
                        self.config.onAuth.call(self, response);
                    }
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    var
                        errors  = [],
                        data    = $.parseJSON(jqXHR.responseText);

                    $.each(data, function(field) {
                        errors.push(data[field][0]);
                    });

                    self.removeMessage().addMessage('danger', errors.join('<br>'));
                    self.config.onFailure.call(self, jqXHR, textStatus, errorThrown);
                });
        },

        getParams: function() {
            return {
                username: this.username.val(),
                password: this.password.val()
            };
        },

        addMessage: function(cssClass, message) {
            this.$container.parent().prepend('<div class="alert alert-primary alert-' + cssClass + ' checkout-error-feedback" role="alert">' + message + '</div>');

            return this;
        },

        removeMessage: function() {
            this.$container.parent().find('.checkout-error-feedback').remove();

            return this;
        },

        reloadPage: function(withHashtag) {
            if(withHashtag) {
                window.location.reload();
            }
            else {
                window.location.href = window.location.href.substr(0, window.location.href.indexOf('#'));
            }

            return this;
        }

    };

    return {
        register: function(btnSelector, containerSelector, url, config) {
            new Form(btnSelector, containerSelector, url, config);
        }
    };

})(jQuery, window);
